"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDrivePadType = exports.getConcretePadType = exports.DriveDocType = exports.DRIVE_EXTENSION = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _SUPPORT_TYPE_MAP;
var DriveDocType;
exports.DriveDocType = DriveDocType;
(function (DriveDocType) {
  DriveDocType["Doc"] = "drive-doc";
  DriveDocType["Sheet"] = "drive-sheet";
  DriveDocType["Text"] = "drive-text";
  DriveDocType["Slide"] = "drive-slide";
  DriveDocType["Pdf"] = "drive-pdf";
  DriveDocType["Unknown"] = "drive-unknown";
})(DriveDocType || (exports.DriveDocType = DriveDocType = {}));
var SUPPORT_TYPE_MAP = (_SUPPORT_TYPE_MAP = {}, (0, _defineProperty2.default)(_SUPPORT_TYPE_MAP, DriveDocType.Doc, /doc|dot|wps|wpt|docx|dotx|docm|dotm/), (0, _defineProperty2.default)(_SUPPORT_TYPE_MAP, DriveDocType.Sheet, /xls|xlt|xlsx|xltx|csv|xlsb|xlsm|xltm|et|ett|ets/), (0, _defineProperty2.default)(_SUPPORT_TYPE_MAP, DriveDocType.Text, /lrc|c|cpp|h|asm|s|java|asp|bat|bas|prg|cmd|rtf|txt|log|xml|htm|html/), (0, _defineProperty2.default)(_SUPPORT_TYPE_MAP, DriveDocType.Slide, /pptx|ppt|pot|potx|pps|ppsx|dps|dpt|pptm|potm|ppsm/), (0, _defineProperty2.default)(_SUPPORT_TYPE_MAP, DriveDocType.Pdf, /pdf/), _SUPPORT_TYPE_MAP);
var DRIVE_EXTENSION = /doc|dot|wps|wpt|docx|dotx|docm|dotm|xls|xlt|xlsx|xltx|csv|xlsb|xlsm|xltm|et|ett|ets|lrc|c|cpp|h|asm|s|java|asp|bat|bas|prg|cmd|rtf|txt|log|xml|htm|html|pptx|ppt|pot|potx|pps|ppsx|dps|dpt|pptm|potm|ppsm|pdf/;
exports.DRIVE_EXTENSION = DRIVE_EXTENSION;
var getConcretePadType = function getConcretePadType(padType) {
  var padTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (padType !== 'drive') return padType;
  for (var _i = 0, _Object$keys = Object.keys(SUPPORT_TYPE_MAP); _i < _Object$keys.length; _i++) {
    var _key = _Object$keys[_i];
    if (SUPPORT_TYPE_MAP[_key].test(padTitle)) {
      return _key;
    }
  }
  return DriveDocType.Unknown;
};
exports.getConcretePadType = getConcretePadType;
var getDrivePadType = function getDrivePadType(extension) {
  for (var _i2 = 0, _Object$keys2 = Object.keys(SUPPORT_TYPE_MAP); _i2 < _Object$keys2.length; _i2++) {
    var _key2 = _Object$keys2[_i2];
    if (SUPPORT_TYPE_MAP[_key2].test(extension)) {
      return _key2;
    }
  }
  return DriveDocType.Unknown;
};
exports.getDrivePadType = getDrivePadType;